/* =====================================================================
   lp-shared.js
   Generisches, abhängigkeitsfreies JS für alle "lp-*" Sections:
   - Carousel (Testimonials / Ingredients): Pfeile scrollen die Liste
   - FAQ Accordion: Klick öffnet/schließt Antwort
   - Buybox: Auswahl Einmalkauf/Abo aktualisiert Preis-Anzeige + Button-Link
   Läuft automatisch beim Laden der Seite und reagiert zusätzlich auf
   Shopify Theme-Editor Events (damit es im Customizer live funktioniert).
   ===================================================================== */
(function () {
  "use strict";

  function initCarousels(root) {
    root.querySelectorAll("[data-lp-carousel]").forEach(function (wrap) {
      if (wrap.dataset.lpInit) return;
      wrap.dataset.lpInit = "1";
      var track = wrap.querySelector("[data-lp-carousel-track]");
      var prev = wrap.querySelector("[data-lp-prev]");
      var next = wrap.querySelector("[data-lp-next]");
      if (!track) return;
      function step() {
        var card = track.querySelector(":scope > *");
        return card ? card.getBoundingClientRect().width + 20 : 300;
      }
      if (prev) prev.addEventListener("click", function () {
        track.scrollBy({ left: -step(), behavior: "smooth" });
      });
      if (next) next.addEventListener("click", function () {
        track.scrollBy({ left: step(), behavior: "smooth" });
      });
    });
  }

  function initAccordions(root) {
    root.querySelectorAll("[data-lp-accordion]").forEach(function (acc) {
      if (acc.dataset.lpInit) return;
      acc.dataset.lpInit = "1";
      var items = acc.querySelectorAll("[data-lp-accordion-item]");
      items.forEach(function (item) {
        var trigger = item.querySelector("[data-lp-accordion-trigger]");
        var panel = item.querySelector("[data-lp-accordion-panel]");
        if (!trigger || !panel) return;
        trigger.addEventListener("click", function () {
          var isOpen = item.classList.contains("is-open");
          if (acc.dataset.single === "true") {
            items.forEach(function (other) {
              other.classList.remove("is-open");
              var otherPanel = other.querySelector("[data-lp-accordion-panel]");
              if (otherPanel) otherPanel.style.maxHeight = null;
            });
          }
          if (!isOpen) {
            item.classList.add("is-open");
            panel.style.maxHeight = panel.scrollHeight + "px";
          } else {
            item.classList.remove("is-open");
            panel.style.maxHeight = null;
          }
        });
      });
    });
  }

  function initBuybox(root) {
    root.querySelectorAll("[data-lp-buybox]").forEach(function (box) {
      if (box.dataset.lpInit) return;
      box.dataset.lpInit = "1";
      var options = box.querySelectorAll("[data-lp-purchase-option]");
      var ctaLink = box.querySelector("[data-lp-cta-link]");

      function applySelection(option) {
        options.forEach(function (o) { o.classList.remove("is-selected"); });
        option.classList.add("is-selected");
        var input = option.querySelector("input");
        if (input) input.checked = true;
        if (ctaLink) {
          var url = option.getAttribute("data-checkout-url");
          if (url) ctaLink.setAttribute("href", url);
          var ctaLabel = option.getAttribute("data-cta-label");
          if (ctaLabel) ctaLink.textContent = ctaLabel;
        }
      }

      options.forEach(function (option) {
        option.addEventListener("click", function () { applySelection(option); });
        var input = option.querySelector("input");
        if (input) {
          input.addEventListener("change", function () { applySelection(option); });
        }
      });

      // Thumbnails <-> Hauptbild
      var mainImg = box.querySelector("[data-lp-gallery-main]");
      box.querySelectorAll("[data-lp-gallery-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          if (mainImg && thumb.dataset.fullSrc) {
            mainImg.setAttribute("src", thumb.dataset.fullSrc);
          }
          box.querySelectorAll("[data-lp-gallery-thumb]").forEach(function (t) {
            t.classList.remove("is-active");
          });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initCarousels(root);
    initAccordions(root);
    initBuybox(root);
  }

  document.addEventListener("DOMContentLoaded", function () { initAll(document); });

  // Shopify Theme-Editor: neu geladene Section-Blöcke erneut initialisieren
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
